import PropTypes from 'prop-types';

import { useCallback } from 'react';
import { usePermissions } from '../hooks/use-permissions';
import { useFeatureFlags } from '../hooks/use-feature-flags';

TfsRoute.propTypes = {
  permission: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
  featureFlag: PropTypes.string,
};

export function TfsRoute(props) {
  const { permission, featureFlag, notFeatureFlag, children } = props;
  const permissions = usePermissions();
  const featureFlags = useFeatureFlags();

  const hasPermission = useCallback(() => {
    const required = [permission].flat();
    return !permission || required.some((p) => permissions.includes(p));
  }, [permission, permissions]);

  if (!hasPermission()) return null;
  if (featureFlag && !featureFlags.includes(featureFlag)) return null;
  if (notFeatureFlag && featureFlags.includes(notFeatureFlag)) return null;

  return children;
}
